<template>
	<div>
		<header id="head" class="pt-3 pb-3 text-center">
			<img class="logo" width="100" src="https://dev.sozpic.com/firvox-agreement/static/img/logo.png" />
		</header>

		<template v-if="error_loading_agreement == ''">
			<template v-if="!loading.agreement">
				<section class="lightgreen-content border-bottom padding-vertical-content">
					<div class="container" v-if="!not_found">
						<div class="row justify-content-center">
							<div class="col-12 col-lg-8 text-center">
								<p class="m-0 bold"><small>Acuerdo</small></p>
								<div class="consent-title h1 mb-2">{{ agreement.title }}</div>
								<div  v-if="!agreement.description">
									<div class="">
										<div class="h5 regular cursive">
											<p>Este documento ha sido creado con la aplicación FirVox Mobile. A continuación, puedes revisar la información y, si estás conforme, grabar tu aceptación diciendo "Yo, &lt;TU NOMBRE&gt; con DNI &lt;TU DNI&gt; acepto el acuerdo" </p>
											{{ agreement.description }}
										</div>
									</div>
								</div>
							</div><!--col-->
						</div>
						<div class="row justify-content-center">
							<div class="col-12 col-lg-10">
			
								<div class="consent-status text-center d-block mb-4" v-if="my_consent">
									<label class="mb-3 ">Estado de mi consentimiento</label>: {{ my_consent.status_str}} <!--({{ my_consent.status }})--></div>
									
									<p class="text-center text-danger" v-if="my_consent.show_message == 1">
										<strong>Tu consentimiento ha sido rechazado</strong> <span v-if="my_consent.motive_owner != null">:
										{{ my_consent.motive_owner }}</span>
									</p>
								
			
								<div v-if="my_consent.status == 0 || my_consent.status == 1">
									<div class="row justify-content-center">
										<div class="col-12 col-lg-7">
											<!-- consent pending -->
											<div class="content white-content padding-content">
												<label class="d-block text-center h4 mb-3">DNI</label>
												<div class="input-content d-flex mb-4">
													<input type="text" name="dni" v-model="dni" class="flex-fill">
													<button type="button" @click="setDNI" class="button gray-content"><i class="fa fa-id-card"></i> Guardar</button>
												</div>
						
												<template v-if="my_consent.dni">
													<div class="mb-4 relative">
														<label class="d-block text-center h4 mt-5 mb-3">CONSENTIMIENTO</label>
														<div id="controls" class="d-flex w-100">
														    <button id="recordButton" class="red-content button flex-fill mr-1" @click="startRecording" :disabled="!record_controls.can_record"><i class="fa fa-circle"></i> Grabar <span class="seconds" v-if="record_controls.recording">{{ record_controls.time }} sec</span></button>
														    <button id="stopButton" class="gray-content button flex-fill ml-1" @click="stopRecording" :disabled="!record_controls.can_stop"><i class="fa fa-pause"></i> Parar</button>
														</div>
													</div>
						
													<button type="button" class="button large-button dark-content w-100" @click="not_agree = true" v-if="!not_agree">Rechazar</button>

													<div v-if="not_agree" class="mt-3">
														<label class="d-block text-center h4 mt-5 mb-3">Indica el motivo</label>

														<textarea v-model="not_agree_motive" class="mb-3"></textarea>

														<button type="button" class="button large-button dark-content w-100" @click="notAgree">Rechazar</button>
													</div>	

													<div v-if="consent_recorded.url != null">
														<audio class="mb-4 w-100 mt-3" controls v-if="consent_recorded.url != null">
															<source :src="consent_recorded.url" type="audio/wav">
														</audio>
														<!--<a :href="consent_recorded.url" download>Descargar audio</a>-->
													</div>
												
												</template>
												<template v-if="my_consent.dni != null && consent_recorded.url != null">
													<!--<div class="legal-terms mb-3">
														<p class="smaller">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet dui et tortor sodales malesuada et in augue. Praesent vel tempus velit, et venenatis felis. Donec lacinia nulla vitae nibh efficitur, non ullamcorper turpis posuere. Donec porta ante sed quam aliquet rutrum. Nunc viverra felis sem, non convallis orci convallis non.												</p>
													</div>-->
													<div class="d-flex mt-4">
													<button type="button" class="button flex-fill large-button green-content mr-1" @click="agree"><i class="fa fa-check"></i> Aceptar y subir consentimiento</button>
													
													</div>
				
												</template>
												<!-- legal terms -->
												<div class="mt-3">
													<div class="input-content">
														<input type="checkbox" v-model="my_consent.legal_terms"/>
														<label>He leído y acepto los <a href="/terms" target="_blank">términos legales</a></label>
														<div v-if="legal_terms_error && !my_consent.legal_terms" class="msg-error">Tienes que aceptar los términos legales antes de continuar</div>
													</div>
												</div>

											</div><!--content-->
										</div><!--col-->
									</div><!--row-->
									
									
								</div>
			
								<div v-if="my_consent.status == 2">
									<!-- consent accepted -->
									<label>Mi DNI: {{ my_consent.dni }}</label>
									<div>
										<audio class="mt-3 mb-3 w-100" controls>
											<source :src="my_consent.file_content" type="audio/wav">
										</audio>
										<!--
										<a :href="my_consent.download_url" download>Descargar audio</a>
										-->
									</div>
								</div>
								
							</div><!--col-->
						</div><!--row-->
					</div><!--container-->
				</section>
				<section class="padding-vertical-content">
					<div class="container">
						<div class="row">
							<div class="col-12">
								<div class="">
									<div class="h4 section-title">Consentimientos </div>
									<div class="padding-content lightgreen-content mb-5" v-if="!loading.consents">
										<ul class="item-list">
											<li v-for="consent in consents">
												<div class="row">
													<div class="col">
														<div class="h4 mb-1">{{ consent.name }}</div>
														<div class="mb-3"><span class="green cursive smaller">{{ consent.email }}</span></div>
														<div class="status">Estado: {{ consent.status_str }}</div>
													</div>
													<div class="col d-flex justify-content-end align-items-center">
														<audio class="mt-3 mb-3 w-100" controls>
															<source  :src="consent.file_content" type="audio/wav">
														</audio>
													</div><!--co-->
												</div><!--row-->
												<!--
												<div>Opciones: 
													<template v-if="consent.download_url">
														<a class="btn btn-info btn-sm" :href="consent.download_url" target="_blank">
															<i class="fa fa-download"></i>
														</a>
													</template>
												</div>-->
											</li>
										</ul>
									</div>
									<div v-else>
										<div class="loader">
											<img src="../assets/loader.svg"/>
										</div>
									</div>
								</div>
							</div><!--col-->
						</div><!--row-->
						<div class="row">
							<div class="col-12 col-lg-6">
								<div class="">
									<div class="h4 section-title">Términos</div>
									<div class="lightgreen-content padding-content" v-if="!loading.terms">
										<ul class="item-list">
											<li v-for="term in terms">
												<div class="title"><span>Título: </span><strong>{{ term.title }}</strong></div>
				                                <div><span class=" preview">Preview</span> 
				
				                                	<div v-if="term.file_type == 'txt'">
				                                		<span class="smaller">{{ term.preview }}</span>
				                                	</div>
				                                	<div v-if="term.file_type == 'audio/wav'">
				                                		<audio class="mt-3 mb-3 w-100" controls>
															<source  :src="term.preview" type="audio/wav">
														</audio>
				                                	</div>
				                                    
										        </div>
										        <!--
												<div>Opciones: 
													<template v-if="term.download_url">
														<a class="btn btn-info btn-sm" :href="term.download_url" target="_blank">
															<i class="fa fa-download"></i>
														</a>
													</template>
												</div>-->
											</li>
										</ul>
									</div>
									<div v-else>
										<div class="loader">
											<img src="../assets/loader.svg"/>
										</div>
									</div>
								</div>
							</div><!--col-->
							<div class="col-12 col-lg-6">
								<div>
									<div class="h4 section-title">Adjuntos</div>
									<div class="lightgreen-content padding-content">
										<ul class="item-list">
											<li v-for="attachment in attachments">
												<div class="title"><span>Título: </span><strong>{{ attachment.title }}</strong></div>
												
					                            <div v-if="!attachment.loading"> <span class="preview">Preview</span>
					                            	<div v-if="attachment.file_type == 'audio/wav'">
					                            		<audio class="w-100" controls>
															<source  :src="attachment.preview" type="audio/wav">
														</audio>
					                            	</div>
					                            	
					                            	<div v-if="attachment.file_type && attachment.file_type.includes('image')">
					                                	<div class="thumb-container ">
					                                		<img class="w-100" :src="attachment.preview">
					                                	</div>
					                            	</div>

					                            	<div v-if="attachment.file_type && attachment.file_type == 'application/vnd.bv.loc'">
					                            		{{ attachment.description }}
					                            		<a :href="'http://maps.google.com/?q=' + attachment.description.replace('/\s/gi ', '+')" target="_blank">Ver en google maps</a>
					                            	</div>

					                            	<div v-if="attachment.file_type && attachment.file_type == 'application/pdf'">
														<a :href="attachment.download_url" target="_blank">{{ attachment.title}}</a>

														<!-- 
					                            		<iframe :src="attachment.preview">
					
					                            		</iframe>
					                            		-->
					                            	</div>
					                            	<div v-if="attachment.file_type && attachment.file_type == 'video/mp4' || attachment.file_type == 'application/octet-stream'">
					                            		<video width="320" height="240" controls>
														  <source :src="attachment.preview" type="video/mp4">
														Your browser does not support the video tag.
														</video>
					                            	</div>	
										        </div>
										        <div v-else>
										        	<div class="loader">
														<img src="../assets/loader.svg"/>
													</div>
										        </div>
										        <!--
												<div> Opciones
													<template v-if="attachment.download_url">
														<a class="btn btn-info btn-sm" :href="attachment.download_url" target="_blank">
															<i class="fa fa-download"></i>
														</a>
													</template>
												</div>-->
											</li>
										</ul>
									</div>
								</div>
							</div><!--col-->
						</div><!--row-->
					</div><!--container-->
				</section>
			</template>
			<template v-else>
				<section class="padding-vertical-content">
					<div class="container" >
						<div class="row justify-content-center">
							<div class="col-12 col-lg-8 text-center">
								<p class="m-0 bold"><small>Cargando acuerdo</small></p>
								
								<div class="loader">
									<img src="../assets/loader.svg"/>
								</div>

							</div><!--col-->
						</div>
					</div>
				</section>
			</template>
		</template>
		<template v-else>
			<section class="padding-vertical-content">
				<div class="container">
					<div class="row justify-content-center">
						<div class="col-12 text-center">
							<div class="message-error">
								<template v-if="error_loading_agreement == 'AGREEMENT_NOT_FOUND'">
									Acuerdo no encontrado
								</template>
								<tempalte v-if="error_loading_agreement == 'CONSENT_NOT_FOUND'">
									Consentimiento no encontrado
								</tempalte>
							</div>	
						</div>
					</div>
				</div>
			</section>
		</template>	
	</div>
</template>

<script>

	import axios from 'axios';

	export default{
		data : function(){
			return {
				urls : {
					agreement : 'agreement?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					dni : 'set-dni?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					agree : 'agree?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					not_agree : 'not-agree?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					upload_consent : 'upload-consent?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					terms : 'terms?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					consents : 'consents?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					attachments : 'attachments?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%',
					attachment : 'attachment?agreement_hash=%AGREEMENT_HASH%&consent_hash=%CONSENT_HASH%'
				},

				not_found : true,
				agreement : {
					title : '',
					description : ''
				},
				terms : [],
				consents : [],
				attachments : [],
				my_consent : {
					dni : ''
				},
				not_agree_motive : '',
				consent_recorded : {
					file : null,
					url : null
				},

				dni : '',
				rec : null,
				audioContext : null,
				AudioContext : null,
				input : null,
				gumStream : null,
				url : 'nain',
				audio_preview : null,
				not_agree : false,
				record_controls : {
					can_record : true,
					can_stop : false,
					recording : false,
					time : 0,
					interval : null
				},

				reject : false,
				reject_motive : '',

				legal_terms_error : false,

				loading : {
					terms : false,
					consents : false,
					agreement : false
				},

				error_loading_agreement : ''
			}
		},

		created : function(){

			//this.iniRecorder();
			this.ini();
		},

		beforeCreate : function(){

		},

		methods : {

			iniRecorder : function(){

				this.AudioContext = window.AudioContext || window.webkitAudioContext;
				this.audioContext = new AudioContext;

			},
			ini : function(){

				var url = this.formatURL(this.urls.agreement);

				this.loading.agreement = true;

				axios.get(url).then( (response) => {

					this.agreement.title = response.data.agreement.title;
					this.agreement.description = response.data.agreement.description;

					this.my_consent = response.data.my_consent;


					this.loading.agreement = false;

					this.attachments = response.data.agreement.attachments;


					for(var i in this.attachments){
						this.getAttachment(i);
					}

					this.getTerms();
					this.getConsents();

					this.dni = this.my_consent.dni;

					this.not_found = false;

					console.log(response.data);
				}).catch((error) => {
					this.error_loading_agreement = error.response.data.message;
					this.not_found = true;
				});
			},

			getTerms : function(){
				var url = this.formatURL(this.urls.terms);

				this.loading.terms = true;

				axios.get(url).then((response) => {
					this.terms = response.data.data;

					this.loading.terms = false;
				}).catch((error) => {
					console.log("ERROR", error);
				});
			},

			getConsents : function(){
				var url = this.formatURL(this.urls.consents);

				this.loading.consents = true;
				
				axios.get(url).then((response) => {
					this.consents = response.data.data;

					this.loading.consents = false;
				}).catch((error) => {
					console.log("ERROR", error);
				})
			},

			getAttachment : function(i){
				var url = this.formatURL(this.urls.attachment);

				url = url + '&attachment_id=' + this.attachments[i].id;

				this.$set(this.attachments[i], 'loading', true);

				this.attachments[i].loading = true;

				axios.get(url).then((response) => {

					console.log("GET THE ATTACHMENTS");
					
					this.attachments[i].preview = response.data.data.preview;
					this.attachments[i].file_type = response.data.data.file_type;
					this.attachments[i].download_url = response.data.data.download_url;

					this.$set(this.attachments[i], 'loading', false);
					
					
				}).catch((error) => {
					console.log("ERROR", error);
				})
			},

			setDNI : function(){


				this.legal_terms_error = false;

				if(this.my_consent.legal_terms){
					var url = this.formatURL(this.urls.dni);

					var params = {
						dni : this.dni,
						legal_terms : this.my_consent.legal_terms
					}

					axios.post(url, params).then( (response) => {

						this.my_consent.dni = this.dni;
					}).catch((error) =>{
						console.log("ERROR", error);
					});
				}else{
					this.legal_terms_error = true;
				}
				
			},

			formatURL : function(url){
				var url = this.config.base_url + url.replace('%AGREEMENT_HASH%', this.$route.query.agreement_hash);
				url = url.replace('%CONSENT_HASH%', this.$route.query.consent_hash);

				return url;

			},

			agree : function(){
				this.legal_terms_error = false;
				if(this.my_consent.legal_terms){
					var url = this.formatURL(this.urls.agree);

					this.uploadConsent();

					var params = {
						legal_terms : this.my_consent.legal_terms
					}
					axios.post(url, params).then( (response) => {
						console.log(response);

						this.ini();
					}).catch((error) =>{
						console.log(error);
					});
				}else{
					this.legal_terms_error = true;
				}
				
			},

			notAgree : function(){
				var url = this.formatURL(this.urls.not_agree);

				var params = {
					motive : this.not_agree_motive
				}

				axios.post(url, params).then( (response) => {
					console.log(response);

					this.ini();
				}).catch((error) =>{
					console.log(error);
				});
			},

			//recording methods
			startRecording : function(){

				this.record_controls.time = 0;
				this.iniRecorder();
				this.record_controls.can_record = false;
				this.record_controls.can_stop = true;
				this.record_controls.recording = true;

				this.record_controls.interval = setInterval( () => {
					this.record_controls.time++
				}, 1000);

				var constraints = {
				    audio: true,
				    video: false
				} 

				navigator.mediaDevices.getUserMedia(constraints).then( (stream) => {
				    /* assign to gumStream for later use */
				    this.gumStream = stream;
				    /* use the stream */
				    this.input = this.audioContext.createMediaStreamSource(stream);
				    /* Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size */
				    this.rec = new Recorder(this.input, {
				        numChannels: 1
				    }) 
				    //start the recording process 
				    this.rec.record();
				})/*.catch((err) => {

					console.log("ERROR AL GRABAR");
					console.log(err);
				})*/;

			},
			pauseRecording  : function(){

			},

			stopRecording : function(){

				this.record_controls.can_record = true;
				this.record_controls.can_stop = false;
				this.record_controls.recording = false;
				clearInterval(this.record_controls.interval);
			    //tell the recorder to stop the recording 
			    this.rec.stop(); //stop microphone access 
			    this.gumStream.getAudioTracks()[0].stop();
			    //create the wav blob and pass it on to createDownloadLink 
			    this.rec.exportWAV((blob) => {
			    	//console.log("hey!", blob);

			    	//https://forum.vuejs.org/t/reactivity-in-audio-control-tag-with-v-bind/1626/2
			    	this.consent_recorded.url = null;
			    	this.consent_recorded.file = null;

			    	this.$nextTick(() => {
			    		this.consent_recorded.url = URL.createObjectURL(blob);  

			    		var reader = new FileReader();

				    	reader.readAsDataURL(blob);

				    	reader.onload = () => {

				    		this.consent_recorded.file = reader.result;
				    	}

			    	});  	
			    });
			},

			uploadConsent : function(){
				var url = this.formatURL(this.urls.upload_consent);

				var params = {
		    		file : this.consent_recorded.file
		    	}

				axios.post(url, params).then( (response) => {
					this.ini();
				}).catch((error) =>{
					console.log(error);
				});
			}
		}
	}


</script>


// WEBPACK FOOTER //
// src/components/AgreementComponent.vue